const DRIVE_INSIGHTS_BASE_URL = '/drive-insights';

export const routeCreator = {
  /**
   * Returns the drive insights route path.
   * Use this for:
   * - Route definitions (parent routes that contain sub-routes)
   * - Path prefix matching (e.g., `pathname.startsWith(routeCreator.base())`)
   * - Navigation links (e.g., `<Link to={routeCreator.base()}>`)
   * - Exact path matching (e.g., `pathname === routeCreator.base()`)
   */
  base: () => DRIVE_INSIGHTS_BASE_URL,
  history: () => `${DRIVE_INSIGHTS_BASE_URL}/history`,
};
